/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOfferNoteEntryRequest } from '../../models/create-offer-note-entry-request';

export interface CreateOfferNoteEntry$Params {
  id: number;
      body?: {
'request': CreateOfferNoteEntryRequest;
'attachments': Array<Blob>;
}
}

export function createOfferNoteEntry(http: HttpClient, rootUrl: string, params: CreateOfferNoteEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createOfferNoteEntry.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createOfferNoteEntry.PATH = '/offers/{id}/note-entries';
